import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Link, Stack, Typography } from "@mui/material";

import React from "react";
import { useTranslation } from "react-i18next";

import { Step } from "../../components";

import { CertificateMethodState } from "./CertificateMethod";

const certificateUploadInstructionUrl = "https://help.scanye.pl/pl/articles/8446433-jak-polaczyc-scanye-z-ksef";

const iconSx = { fontSize: 36, color: "primary.main" } as const;

export type CertificateMethodStepsProps = {
  steps: CertificateMethodState["steps"];
  onMoveToKSef: () => void;
  onOpenUploadStep: () => void;
};

export const CertificateMethodSteps: React.FC<CertificateMethodStepsProps> = ({
  steps,
  onMoveToKSef,
  onOpenUploadStep,
}) => {
  const { t } = useTranslation();
  const step1Done = Boolean(steps[1]);
  const step2Done = Boolean(steps[2]);

  return (
    <Stack gap={2}>
      <Typography variant="body2" color="error">
        {t("certificateMethod.limitWarning")}
      </Typography>

      <Step
        step={1}
        titleLoc="certificateMethod.moveToKSef"
        description={
          <>
            {t("certificateMethod.description")}{" "}
            <Link
              href={certificateUploadInstructionUrl}
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
              sx={{ fontWeight: 600 }}
            >
              {t("certificateMethod.seeInstruction")}
            </Link>
          </>
        }
        icon={<ExitToAppOutlinedIcon sx={iconSx} />}
        buttonLabelLoc="common.moveOn"
        replayLabelLoc="common.goAgain"
        done={step1Done}
        onClick={onMoveToKSef}
      />

      <Step
        step={2}
        titleLoc="certificateMethod.uploadFiles"
        description="certificateMethod.uploadFilesDescription"
        icon={<FileUploadOutlinedIcon sx={iconSx} />}
        buttonLabelLoc="common.add"
        showDone={false}
        done={step2Done}
        disabled={!step1Done}
        onClick={onOpenUploadStep}
      />
    </Stack>
  );
};
